export default __webpack_public_path__ + "static/header-67d8767431f9e1c1746a6209bae9f40a63b8ccb33f588a899dd99f9aa89d0edc.png";